var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app"},[(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('keep-alive',[_c('Foot')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }